var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.7 1.3 4 4a1 1 0 0 1 0 1.4l-12 12a1 1 0 0 1-.7.3H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 .3-.7l12-12a1 1 0 0 1 1.4 0M18 3.4l-11 11V17h2.59l11-11L18 3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M11 4a1 1 0 0 1-1 1H3.5a.5.5 0 0 0-.5.5v15c0 .28.22.5.5.5h15a.5.5 0 0 0 .5-.5V14a1 1 0 0 1 2 0v6.5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 1 20.5v-15A2.5 2.5 0 0 1 3.5 3H10a1 1 0 0 1 1 1"
  }))));
};
export default SvgEdit;